import React, {useEffect, useState} from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { Card, CardBody, Col, Container, Row, Button, FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import {Form, Field} from "react-final-form";
import renderSelectField from '@/shared/components/form/Select';
import { ToggleButtonField } from '@/shared/components/form/ToggleButton';
import Select from 'react-select';
import getRewardPlatform from "@/service/getRewardPlatform";
import {labelizeNamedData, labelizeNamedRow} from '@/shared/helpers'

const AddConfigurationPage = () => {
    const [formData, setFormData] = useState({
        name: '',
        platform_name: '',
        platform_key: '',
        platform_url: '',
        platform_mode: '',
        account_identifier: '',
        account_number: '',
        customer_number: '',
        udid: '',
        etid: '',
        status: false,
        is_test: false,
        toa_merchant_min_value: '',
        toa_merchant_max_value: ''
    });
    const [errors, setErrors] = useState({});
    const [selectedPlatform, setSelectedPlatform] = useState(null);
    const history = useHistory();
    const [rewardPlatforms, setRewardPlatforms] = React.useState([])

    useEffect(() => {
        if (rewardPlatforms.length === 0) {
            getRewardPlatform()
              .then(result => {
                  setRewardPlatforms(labelizeNamedData(result))
              })
        }
    },)

    const validateForm = (platformValue) => {
        let valid = true;
        let newErrors = {};

        const isNeo = platformValue?.label?.toLowerCase().includes('neo');
        console.log('isNeo:', isNeo, 'formData:', formData);
        const requiredFields = isNeo
            ? ['name', 'platform_name', 'platform_mode', 'account_identifier']
            : ['name', 'platform_name', 'platform_key', 'platform_url', 'platform_mode', 'account_identifier', 'customer_number', 'udid', 'etid'];

        requiredFields.forEach(field => {
            if (!formData[field]) {
                valid = false;
                newErrors[field] = 'This field is required';
            }
        });

        setErrors(newErrors);
        return valid;
    };

    const handleChange = (e) => {
        const { name, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? (checked ? 1 : 0) : e.target.value
        }));
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: undefined
            }));
        }
    };

    const onSubmit = async (values) => {
        console.log('onSubmit values:', values);
        if (!validateForm(values?.reward_platform_id)) {
            alert('Please fill all required fields.');
            return;
        }

        formData.reward_platform_id = values?.reward_platform_id.value;
        const submitData = {
            ...formData,
            status: formData.status ? 1 : 0,
            is_test: formData.is_test ? 1 : 0
        };

        try {
            const response = await axios.post(`/tango-settings/create`, submitData);
            history.push(`/reward-platform-settings/view/${response.data.newConfigurationId}`);
        } catch (error) {
            console.error('Failed to add new configuration:', error);
            alert('Error adding new configuration');
        }
    };

    return (
        <Container>
            <Row>
                <Col md={12}>
                    <h2>Add New Reward Platform Configuration</h2>
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <Card>
                        <CardBody>
                            <Form
                              onSubmit={onSubmit}
                            >
                                {({ handleSubmit, form, submitting, pristine, values }) => (
                            <form onSubmit={handleSubmit}>
                                <Field name="reward_platform_id">
                                    {({ input, meta }) => (
                                      <div className="form__form-group">
                                          <span className="form__form-group-label">Reward Platform</span>
                                          <div className="form__form-group-field">
                                              <div className="form__form-group-row">
                                                  <Field
                                                    name="reward_platform_id"
                                                    component={renderSelectField}
                                                    options={rewardPlatforms}
                                                    onChange={(val) => setSelectedPlatform(val)}
                                                  />
                                                  {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
                                              </div>
                                          </div>
                                      </div>
                                    )}
                                </Field>
                                <Row>
                                    {['name', 'platform_name', 'platform_key', 'platform_url', 'platform_mode', 'account_identifier', 'account_number', 'customer_number', 'udid', 'etid', 'toa_merchant_min_value', 'toa_merchant_max_value'].map(field => (
                                        <Col md={6} key={field}>
                                            <FormGroup>
                                                <Label for={field}>{({ customer_number: 'Customer Number / Client Id', account_identifier: 'Account Identifier / Brand Id' })[field] || (field.replace(/_/g, ' ').charAt(0).toUpperCase() + field.replace(/_/g, ' ').slice(1))}:</Label>
                                                <Input
                                                    type="text"
                                                    id={field}
                                                    name={field}
                                                    value={formData[field]}
                                                    onChange={handleChange}
                                                    invalid={!!errors[field]}
                                                />
                                                <FormFeedback>{errors[field]}</FormFeedback>
                                            </FormGroup>
                                        </Col>
                                    ))}
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label>Configuration</Label>
                                            <Select
                                                options={[{ value: 0, label: 'Production' }, { value: 1, label: 'Test' }]}
                                                value={formData.is_test ? { value: 1, label: 'Test' } : { value: 0, label: 'Production' }}
                                                onChange={opt => setFormData(prev => ({ ...prev, is_test: opt.value }))}
                                                className="react-select"
                                                classNamePrefix="react-select"
                                                styles={{ menuList: base => ({ ...base, top: 0 }) }}
                                            />
                                        </FormGroup>
                                        <div className="d-flex align-items-center mb-2">
                                            <span className="mr-2" style={{ minWidth: 130 }}>Active</span>
                                            <div style={{ width: 60 }}>
                                                <ToggleButtonField
                                                    name="status"
                                                    value={!!formData.status}
                                                    onChange={val => setFormData(prev => ({ ...prev, status: val ? 1 : 0 }))}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12}>
                                        <Button type="submit" color="primary">Save Changes</Button>
                                        <Button type="button" onClick={() => history.goBack()} color="secondary">Cancel</Button>
                                    </Col>
                                </Row>
                            </form>
                                )}
                            </Form>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default AddConfigurationPage;
